import { DocumentNode } from './DocumentNode'

export const useFlowchartViewModel = () => {
    
    const calculateNodesAndEdges = titleBreakdown => {
        
        const edges = []
        const nodes = []
        const nodesMap = {}
        
        const existingEdges = {}
        
        titleBreakdown.documents?.forEach(doc => {
            nodesMap[doc.documentId] = {
                id: doc.documentId,
                data: { ...doc.value, name: doc.name, id: doc.documentId },
                position: { x: null, y: 0 },
                type: 'document',
            }
            nodes.push(nodesMap[doc.documentId])
            
            titleBreakdown.documents.forEach(doc2 => {
                const edgeId = `${doc.documentId}->${doc2.documentId}`
                
                if (doc.value.grantees
                    .some(gtee => doc2.value.grantors
                        .some(gtor => gtor.id === gtee.id)) && !existingEdges[edgeId]) {
                    existingEdges[edgeId] = { id: edgeId, source: doc.documentId, target: doc2.documentId }
                    edges.push(existingEdges[edgeId])
                }
            })
            
        })
        
        const nodesWithoutParent = new Set(edges.map(e => e.source))
        
        const nodesWithoutEdges = new Set()
        
        const docIds = new Set(Object.keys(existingEdges).map(e => e.split('->')).flat())
        
        nodes.forEach(node => {
            if (!docIds.has(node.id))
                nodesWithoutEdges.add(node.id)
        })
        
        let edgesCopy = [...edges]
        
        edges.forEach(edge => {
            if (nodesWithoutParent.has(edge.target))
                nodesWithoutParent.delete(edge.target)
        })
        
        const levels = [nodesWithoutEdges, nodesWithoutParent]
        
        let lvlIdx = 0
        
        let breakpoint = 0
        
        while (edgesCopy.length && breakpoint < 30) {
            
            const deletableIdx = new Set()
            
            edgesCopy.forEach((ec, idx) => {
                
                try {
                    
                    if (levels[lvlIdx].has(ec.source)) {
                        deletableIdx.add(idx)
                        levels[lvlIdx + 1] = levels[lvlIdx + 1] || new Set()
                        levels[lvlIdx + 1].add(ec.target)
                    }
                } catch (err) {
                    // just silencing the error so far so it renders the chart
                    console.log(err)
                }
            })
            
            edgesCopy = edgesCopy.filter((_, idx) => !deletableIdx.has(idx))
            breakpoint++
            lvlIdx++
        }
        
        let yPosition = 0
        
        levels.forEach(level => {
            const nodesCount = (level.size - 1) / 2
            let xPosition = nodesCount * -400
            
            Array.from(level).forEach(id => {
                if (nodesMap[id].position.x === null) {
                    nodesMap[id].position.y = yPosition
                    nodesMap[id].position.x = xPosition
                    nodesMap[id].data.name = nodesMap[id].data.name + ' - ' + xPosition
                    xPosition += 400
                }
            })
            
            yPosition += 500
            
        })
        
        return {
            nodes,
            edges,
        }
        
    }
    
    return {
        calculateNodesAndEdges,
    }
    
}

export const nodeTypes = {
    'document': DocumentNode,
}
